<template>
   <span :style="style">
      <slot />
   </span>
</template>

<script>
export default {
   // eslint-disable-next-line vue/multi-word-component-names
   name: 'Pin',
   props: {
      fixed: {
         type: Boolean,
         default: false,
      },
      top: {
         type: String,
         default: null,
      },
      right: {
         type: String,
         default: null,
      },
      bottom: {
         type: String,
         default: null,
      },
      left: {
         type: String,
         default: null,
      },
   },
   computed: {
      style() {
         let style = {
            position: this.fixed ? 'fixed' : 'absolute',
            zIndex: 1000,
         };
         let directionCount = 0;
         for (const direction of ['top', 'right', 'bottom', 'left']) {
            let val = this[direction];
            if (val !== null) {
               directionCount++;
               if (/^\d+$/.test(val) && val !== '0') {
                  val += 'px';
               }
               style[direction] = val;
            }
         }
         if (directionCount === 0) {
            style = { ...style, top: '5px', left: '5px' };
         }
         return style;
      },
   },
};
</script>
